export default __webpack_public_path__ + "static/media/Vector.0c3c8340.svg";